<template>
  <div class="home">
    <div class="banner">
      <img src="../asset/aike/clbanner.png" alt="" />
      <div class="content">
        <p class="t1 wow fadeInUp">Strategic vision</p>
        <p class="t2 wow fadeInUp" v-if="$i18n.locale == 'zh-CN'">战略愿景</p>
        <div class="info wow fadeInUp">
          <!-- <p>{{ $t("culture").texts[0] }}</p> -->
          <p>{{ $t("culture").texts[1] }}</p>
        </div>
      </div>
    </div>

    <!--    企业文化-->
    <!-- <div class="main" id="div1">
      <p class="title wow fadeInUp">{{$t('culture').text0}}</p>
      <div class="allItems wow fadeInUp">
          <div class="item" v-for="(item,index) in list" :key="index">
            <div class="circle">
              <div class="pic">
                <img :src="item.img" alt="">
              </div>
              <div class="t1">
                  {{item.title}}
              </div>
            </div>
            <div class="intro">
               <div class="t1">
                  <p v-if="$i18n.locale=='zh-CN'">{{item.title}}</p>
                 <p>{{item.title2}}</p>
               </div>
              <div class="t2">
                 <p v-html="item.intro"></p>
              </div>
            </div>
          </div>
      </div>
    </div> -->

    <!--    战略愿景-->
    <div class="vision" id="threeNums">
      <!-- <div class="content">
        <p class="t1 wow fadeInUp">Strategic vision</p>
        <p class="t2 wow fadeInUp" v-if="$i18n.locale == 'zh-CN'">战略愿景</p>
        <div class="info wow fadeInUp">
          <p>{{ $t("culture").texts[0] }}</p>
          <p>{{ $t("culture").texts[1] }}</p>
        </div>
      </div> -->
    </div>

    <foot></foot>
  </div>
</template>

<script>
import foot from "@/components/foot.vue";
import Scrollbar from "smooth-scrollbar";

export default {
  name: "home",
  data() {
    return {
      scrollbar: "",
      list: [
        {
          img: require("../asset/aike/pz.png"),
          title: "品质",
          title2: "quality",
          intro: `达到世界先进企业经营效率<br>成为拥有多个国际市场知名产品品牌的跨国企业。`,
        },
        {
          img: require("../asset/aike/cx.png"),
          title: "诚信",
          title2: "Integrity",
          intro: `达到世界先进企业经营效率<br>成为拥有多个国际市场知名产品品牌的跨国企业。`,
        },
        {
          img: require("../asset/aike/jq.png"),
          title: "激情",
          title2: "Passion",
          intro: `达到世界先进企业经营效率<br>成为拥有多个国际市场知名产品品牌的跨国企业。`,
        },
        {
          img: require("../asset/aike/xl.png"),
          title: "效率",
          title2: "quality",
          intro: `达到世界先进企业经营效率<br>成为拥有多个国际市场知名产品品牌的跨国企业。`,
        },
        {
          img: require("../asset/aike/fw.png"),
          title: "服务",
          title2: "service",
          intro: `达到世界先进企业经营效率<br>成为拥有多个国际市场知名产品品牌的跨国企业。`,
        },
        {
          img: require("../asset/aike/chuangxin.png"),
          title: "创新",
          title2: "Innovation",
          intro: `达到世界先进企业经营效率<br>成为拥有多个国际市场知名产品品牌的跨国企业。`,
        },
      ],
    };
  },
  mounted() {
    let threeNums = document.getElementById("threeNums");
    Scrollbar.initAll(document.getElementById("scroller-wrapper"));
    this.scrollbar = Scrollbar.get(document.getElementById("scroller-wrapper"));
    this.scrollbar.scrollTo(0, 1);
    this.scrollbar.addListener((status) => {
      window.pageYOffset = this.scrollbar.scrollTop;
      threeNums.style = `background-position-y:${this.scrollbar.scrollTop}px;`;
    });
    setTimeout(() => {
      if (window.location.search.replace("?", "").split("=")[1] !== undefined) {
        this.change(parseInt(this.getNid()));
      }
    }, 100);
  },
  components: { foot },
  methods: {
    getNid() {
      return window.location.search
        .replace("?", "")
        .split("=")[1]
        .split("?")[0];
    },
    change(n) {
      this.select = n;
      if (n === 0) {
        Scrollbar.get(
          document.getElementById("scroller-wrapper")
        ).scrollIntoView(document.querySelector("#div1"), {
          offsetTop: 120,
        });
      } else if (n === 1) {
        Scrollbar.get(
          document.getElementById("scroller-wrapper")
        ).scrollIntoView(document.querySelector("#threeNums"), {
          offsetTop: 120,
        });
      }
    },
  },
};
</script>
<style  lang="scss" scoped>
.home {
  width: 100%;
  .banner {
    width: 100%;
    height: 100vh;
    overflow: hidden;
    position: relative;
    img {
      width: 100%;
      display: block;
      object-fit: cover;
      height: 100%;
      animation: sbig 5s linear forwards;
      filter: brightness(.4);
    }
    // .content{
    //   position: absolute;
    //   top: 50%;
    //   left: 50%;
    //   transform: translate(-50%,-50%);
    // }
    .content {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
      width: 80%;
      margin: 0 auto;
      text-align: center;
      .t1 {
        font-size: 60px;
        color: white;
        font-family: "ITCAvantGardeStd-Bk";
        text-transform: uppercase;
        animation-duration: 2s;
      }
      .t2 {
        font-size: 40px;
        font-family: "SOURCEHANSANSCN-REGULAR";
        color: white;
        margin: 30px auto;
        animation-duration: 2s;
      }
      .info {
        width: 80%;
        margin: 0 auto;
        padding-top: 40px;
        animation-duration: 2s;
        p:nth-child(1) {
          font-size: 20px;
          font-family: "SOURCEHANSANSCN-NORMAL";
          margin: 30px 0;
          color: white;
          opacity: 0.8;
        }
        p:nth-child(2) {
          font-family: "SOURCEHANSANSCN-NORMAL";
          line-height: 40px;
          color: white;
          opacity: 0.8;
        }
      }
    }
    @keyframes sbig {
      from {
        transform: scale(1);
      }
      to {
        transform: scale(1.05);
      }
    }
  }
  .main {
    width: 80%;
    margin: 60px auto;
    .title {
      text-align: center;
      color: #343434;
      font-size: 38px;
      font-family: "SOURCEHANSANSCN-MEDIUM";
      animation-duration: 2s;
    }
    .allItems {
      width: 100%;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: space-between;
      margin: 60px auto;
      animation-duration: 2s;
      .item {
        width: 30%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        margin-bottom: 60px;
        .circle {
          width: 90px;
          height: 90px;
          background: rgba(245, 245, 245, 1);
          border-radius: 50%;
          position: relative;
          transition: all 600ms;
          .pic {
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            transition: all 600ms;
          }
          .t1 {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            transform: rotateY(180deg);
            text-align: center;
            line-height: 90px;
            color: #0c4ea2;
            font-size: 25px;
            font-family: "SOURCEHANSANSCN-MEDIUM";
            opacity: 0;
            transition: all 600ms;
          }
        }
        .intro {
          position: relative;
          width: 100%;
          transition: all 600ms;
          .t1 {
            text-align: center;
            transition: all 600ms;
            p:nth-child(1) {
              color: #666666;
              font-size: 25px;
              font-family: "SOURCEHANSANSCN-MEDIUM";
              margin: 15px auto;
            }
            p:nth-child(2) {
              color: #cecece;
              font-family: "it";
              text-transform: uppercase;
            }
          }
          .t2 {
            position: absolute;
            left: 0;
            top: 15px;
            width: 100%;
            transform: rotateY(180deg);
            transition: all 600ms;
            opacity: 0;
            p {
              text-align: center;
              color: #666666;
              font-family: "SOURCEHANSANSCN-LIGHT";
              line-height: 30px;
            }
          }
        }
        &:hover {
          .circle {
            transform: rotateY(180deg);
            .pic {
              transform: rotateY(180deg);
              opacity: 0;
            }
            .t1 {
              opacity: 1;
            }
          }
          .intro {
            transform: rotateY(180deg);
            .t1 {
              transform: rotateY(180deg);
              opacity: 0;
            }
            .t2 {
              opacity: 1;
            }
          }
        }
      }
    }
  }
  .vision {
    width: 100%;
    // background: url("../asset/aike/vng.png") no-repeat;
    // background-size: cover;
    // background-attachment: fixed;
    // padding: 250px 0;
    .content {
      width: 80%;
      margin: 0 auto;
      text-align: center;
      .t1 {
        font-size: 60px;
        color: white;
        font-family: "ITCAvantGardeStd-Bk";
        text-transform: uppercase;
        animation-duration: 2s;
      }
      .t2 {
        font-size: 40px;
        font-family: "SOURCEHANSANSCN-REGULAR";
        color: white;
        margin: 30px auto;
        animation-duration: 2s;
      }
      .info {
        width: 80%;
        margin: 0 auto;
        padding-top: 40px;
        animation-duration: 2s;
        p:nth-child(1) {
          font-size: 20px;
          font-family: "SOURCEHANSANSCN-NORMAL";
          margin: 30px 0;
          color: white;
          opacity: 0.8;
        }
        p:nth-child(2) {
          font-family: "SOURCEHANSANSCN-NORMAL";
          line-height: 40px;
          color: white;
          opacity: 0.8;
        }
      }
    }
  }
}
@media screen and (max-width:1000px) {
  .home{
    .banner{
      .content{
        .t1{
          font-size: 30px;
        }
        .t2{
          font-size: 28px;
        }
        .info{
          width: 90%;
          p:nth-child(1){
            font-size: 18px;
            line-height: 30px;
          }
        }
      }
    }
  }
}
</style>
